import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';
import moment from 'moment';

export default {
	async getCommCodes(codeType) {
		//console.log('codeType', codeType);
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/undefined/commonCodes?commCdType=${codeType}`);
			return response?.data || null;
		} catch (error) {
			throw error.response?.data;
		}
	},
	getClamMstList: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		/*날짜 포멧변환*/
		let startDcsnDd, endDcsnDd, causPartNo;

		//날짜 값이 없으면 날짜 포멧을 할수가 없다.

		if (searchParams.startDcsnDd) {
			startDcsnDd = moment(searchParams.startDcsnDd).format('YYYYMMDD');
		} else {
			startDcsnDd = '';
		}

		if (searchParams.endDcsnDd) {
			endDcsnDd = moment(searchParams.endDcsnDd).format('YYYYMMDD');
		} else {
			endDcsnDd = '';
		}

		/*특수문자가 있는것들은 다음과 같이해줘됨 */
		if (searchParams.causPartNo) {
			causPartNo = encodeURIComponent(searchParams.causPartNo);
		} else {
			causPartNo = '';
		}

		queryStr = objectToQuerystring({
			dlrCpnyCd: searchParams.dlrCpnyCd /*딜러점*/,
			causPartNo: causPartNo /*품번*/,
			prcStepGb: searchParams.prcStepGb /*처리단계*/,

			prcRsltCd: searchParams.prcRsltCd /*처리결과*/,
			prcClmDd: searchParams.prcClmDd /* 검색날짜구분값*/,
			ctype: searchParams.ctype /*ctype*/,
			cmpnNo: searchParams.cmpnNo /*캠페인번호*/,
			clmNo: searchParams.clmNo /*클레임번호*/,
			roNo: searchParams.roNo /*RO번호*/,
			dlvgNm:searchParams.dlvgNm,
			startDcsnDd: startDcsnDd /*확정일자from*/,
			endDcsnDd: endDcsnDd /*확정일자to*/,
			currentPage,
			pageUnit
		});

		//console.log('queryStr', queryStr);

		return client
			.get(`${BASE_URL}/mqy/qlty/clamMst/v1/clams` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},

	getRoApcnPopList(paramRoNo) {
		//console.log('RO번호>>>', paramRoNo);

		return client
			.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${paramRoNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getClamNoPopList(paramClamNo) {
		return client
			.get(`${BASE_URL}/mqy/qlty/clamMst/v1/clmNo/${paramClamNo}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	saveClamMstPopup: ({ formData }) => {
		let url = `${BASE_URL}/mqy/qlty/clamMst/v1/status/1/`;

		return client
			.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	fileDownload: ({ params }) => {
		// console.log('params', params);
		// 이미지 미리보기와 실제파일 다운로드에서 같이 사용하기 때문에 주의할것
		return new Promise((resolve, reject) => {
			client
				.post(`${BASE_URL}/comm/common/qmsFileInfo/v1/downloadFiles`, params, { responseType: 'blob' })
				.then(response => {
					resolve(response);
				})
				.catch(error => reject(new Error(error.message || error.response)));
		});
	},
	saveStateAppr: ({ clamMstPopUp }) => {
		return client
			.post(`${BASE_URL}/mqy/qlty/clamMst/v1/status/2/clmNo/${clamMstPopUp.clmNo}/apprA`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getCalAplRpymAmt(param) {
		let queryStr = '';

		queryStr = objectToQuerystring({
			cmpnNo: param.cmpnNo /*캠페인번호*/,
			rtsh: param.rtsh /*적용변제율*/
		});

		return (
			client
				//.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${param.roNo}/cpnyCd/${param.cpnyCd}/rtsh/${param.rtsh}`)
				.get(`${BASE_URL}/mqy/qlty/clamMst/v1/roNo/${param.roNo}/cpnyCd/${param.cpnyCd}/causPartNo/${param.causPartNo}` + queryStr)
				.then(response => (response && response.data) || null)
				.catch(error => {
					throw error.response.data;
				})
		);
	}
};
